/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import React from 'react';
import { SaveNowBadge } from '@/features/shelf/components/PageTemplates/Shelf/ResultsList/SaveNowBadge';
import { RebateOnlyBadge } from '@/features/pdp/components/RebateOnlyBadge';

export interface ProductAvailabilityInfoBadgeProps {
  dealAvailable: boolean;
  rebatesAvailable: boolean;
  rebateUrl?: string;
  rebateShortDesc?: string;
  dealDrawerPDPEnabled: boolean;
  onDealsClick?: () => void;
}

export const ProductAvailabilityInfoBadge: React.FC<ProductAvailabilityInfoBadgeProps> = ({
  dealAvailable,
  rebatesAvailable,
  rebateUrl,
  rebateShortDesc,
  dealDrawerPDPEnabled,
  onDealsClick,
}) => {
  const badgeDetails = {
    dealAvailable,
    rebatesAvailable,
    rebateUrl,
    rebateShortDesc,
  };

  if (!dealDrawerPDPEnabled) {
    if (dealAvailable || rebatesAvailable) {
      return <SaveNowBadge badgeDetails={badgeDetails} dealsCheck={onDealsClick} />;
    }
  } else if (dealDrawerPDPEnabled && rebatesAvailable) {
    return <RebateOnlyBadge badgeDetails={badgeDetails} withShortDescription />;
  }

  return null;
};
